import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isPlacementMode: false,
  newPolygon: {},
  isPlaced: false,
  placedPolygons: [],
  editingPolygonId: null,
};

const polygonPlacementSlice = createSlice({
  name: "polygonPlacement",
  initialState,
  reducers: {
    setIsPolygonPlacementMode: (state, action) => {
      state.isPlacementMode = action.payload;
    },
    setNewPolygon: (state, action) => {
      state.newPolygon = action.payload;
    },
    setEditingPolygonId: (state, action) => {
      state.editingPolygonId = action.payload;
    },
    setIsPlaced: (state, action) => {
      state.isPlaced = action.payload;
    },
    loadPolygon: (state, action) => {
      const { polygon } = action.payload;

      state.editingPolygonId = polygon.id;
      state.newPolygon = polygon.verts;
      state.isPlaced = true;
      state.isPlacementMode = true;
    },

    addPlacedPolygon: (state, action) => {
      state.placedPolygons.push(action.payload);
    },
    removePlacedPolygon: (state, action) => {
      state.placedPolygons = state.placedPolygons.filter(
        (polygon) => polygon.id !== action.payload
      );
    },

    resetPlacement: (state) => {
      state.newPolygon = initialState.newPolygon;
      state.isPlaced = initialState.isPlaced;
      state.editingPolygonId = initialState.editingPolygonId;
    },
  },
});

export const {
  setIsPolygonPlacementMode,
  loadPolygon,
  setNewPolygon,
  addPlacedPolygon,
  removePlacedPolygon,
  resetPlacement,
  setIsPlaced,
  setEditingPolygonId,
} = polygonPlacementSlice.actions;

export default polygonPlacementSlice.reducer;
